import React, { type ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface PolicyLayoutProps {
  title: string;
  subtitle?: string;
  badge?: string;
  children: ReactNode;
}

const PolicyLayout: React.FC<PolicyLayoutProps> = ({ title, subtitle, badge, children }) => {
  return (
    <div className="min-h-screen w-full bg-[var(--secondary)] text-[var(--text-primary)] font-sans selection:bg-[var(--primary)] selection:text-white overflow-x-hidden">

      <div className="relative z-10 flex w-full flex-col items-center">
        <Navbar />

        {/* Policy Hero Section */}
        <section className="w-full bg-[var(--secondary)] pt-44 pb-20 px-6 lg:px-24 flex items-center relative overflow-hidden">

          {/* Decorative Corner Accents */}
          <div className="absolute top-[-10%] left-[-5%] w-[40vw] h-[40vw] bg-[var(--primary)] opacity-[0.03] rounded-full blur-[120px] pointer-events-none" />
          <div className="absolute bottom-[-10%] right-[-5%] w-[35vw] h-[35vw] bg-[var(--secondary-accent)] opacity-[0.04] rounded-full blur-[120px] pointer-events-none" />

          <div className="max-w-[1200px] mx-auto text-center relative z-10">
            {badge && (
              <div className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-[var(--primary)]/10 text-[var(--primary)] font-black text-xs uppercase tracking-[0.3em] mb-8">
                {badge}
              </div>
            )}

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-[var(--primary)] tracking-tighter mb-8 leading-tight">
              {title}
            </h1>

            {subtitle && (
              <p className="text-[var(--text-gray)] font-bold text-xl lg:text-2xl max-w-2xl mx-auto leading-relaxed opacity-80">
                {subtitle}
              </p>
            )}
          </div>
        </section>

        {/* Content Section */}
        <div className="w-full bg-white py-24 relative z-10 border-t border-[var(--border-light)]">
          <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
            <div className="prose prose-slate max-w-none 
              prose-headings:text-[#0F172A] prose-headings:font-black prose-headings:tracking-tight
              prose-p:text-[var(--text-secondary)] prose-p:font-medium prose-p:leading-relaxed
              prose-strong:text-[#0F172A] prose-strong:font-black
              prose-ul:list-disc prose-li:text-[var(--text-secondary)]
              space-y-12">
              {children}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PolicyLayout;
